module.exports = __webpack_public_path__ + "img/qr-code-scan.cee662f2.svg";